/* Perry Ellis MX - linked color products + size-aware availability */
(() => {
  const normalize = (value) => String(value || '')
    .trim()
    .toLocaleLowerCase('es-MX')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const SIZE_ALIASES = ['talla', 'size', 'tamano', 'tamaño'];

  function getMainProduct() {
    return document.querySelector('product-info[data-main-product]');
  }

  function getSelectedSize(root, preferredName) {
    if (!root) return null;
    const preferred = normalize(preferredName);
    const controls = [...root.querySelectorAll('.product-form__input[data-option-name]')];
    let control = controls.find(el => normalize(el.dataset.optionName) === preferred);
    if (!control) control = controls.find(el => SIZE_ALIASES.includes(normalize(el.dataset.optionName)));
    if (!control) return null;

    const radio = control.querySelector('input[type="radio"]:checked');
    if (radio) return radio.value;
    const select = control.querySelector('select');
    if (select) return select.value;
    return null;
  }

  function getSizeIndex(options, preferredName) {
    const preferred = normalize(preferredName);
    let idx = options.findIndex(name => normalize(name) === preferred);
    if (idx < 0) idx = options.findIndex(name => SIZE_ALIASES.includes(normalize(name)));
    return idx;
  }

  function findVariantForSize(data, size, preferredName) {
    if (!data || !Array.isArray(data.options) || !Array.isArray(data.variants) || !size) return null;
    const sizeIndex = getSizeIndex(data.options, preferredName);
    if (sizeIndex < 0) return null;
    const wanted = normalize(size);
    return data.variants.find(variant => Array.isArray(variant.options) && normalize(variant.options[sizeIndex]) === wanted) || null;
  }

  function updateColorAvailability() {
    const main = getMainProduct();
    if (!main) return;
    const groups = main.querySelector('[data-pe-color-groups]');
    if (!groups) return;

    const sizeOption = groups.dataset.sizeOption || 'Talla';
    const selectedSize = getSelectedSize(main, sizeOption);

    groups.querySelectorAll('[data-pe-color-product]').forEach(item => {
      const link = item.querySelector('[data-pe-color-link]');
      const script = item.querySelector('[data-pe-color-variants]');
      if (!link || !script) return;

      let data;
      try { data = JSON.parse(script.textContent); } catch (e) { return; }

      item.classList.remove('pe-color-unavailable-for-size');
      link.removeAttribute('aria-disabled');
      link.removeAttribute('data-size-unavailable');
      link.href = link.dataset.baseUrl || link.getAttribute('href');

      if (!selectedSize) return;
      const variant = findVariantForSize(data, selectedSize, sizeOption);

      if (!variant || !variant.available) {
        item.classList.add('pe-color-unavailable-for-size');
        link.setAttribute('aria-disabled', 'true');
        link.dataset.sizeUnavailable = 'true';
        link.title = `${link.title || 'Color'} — talla ${selectedSize} no disponible`;
        return;
      }

      const baseUrl = link.dataset.baseUrl || link.getAttribute('href').split('?')[0];
      link.href = `${baseUrl}?variant=${variant.id}`;
    });
  }

  // Prevent navigating to a sibling color that does not have the selected size.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-pe-color-link][data-size-unavailable="true"]');
    if (!link) return;
    event.preventDefault();
  });

  // The theme may replace product HTML after a variant/product change, so use delegated events.
  document.addEventListener('change', event => {
    if (!event.target.closest('product-info[data-main-product] product-variant-selects')) return;
    window.requestAnimationFrame(updateColorAvailability);
    setTimeout(updateColorAvailability, 150);
  });

  document.addEventListener('product-info:loaded', () => {
    window.requestAnimationFrame(updateColorAvailability);
  });

  document.addEventListener('DOMContentLoaded', updateColorAvailability);
  window.addEventListener('pageshow', updateColorAvailability);
})();
